import { gql } from '@apollo/client';

export const GQL_GetWarnings = gql`
  query {
    userAutoPilotWarningsGet {
      warningPrompts {
        title
        description
        type
          priority
          slavePortfolioKey
          actionType
          options {
            route
            bannerColor
            customBannerColor
            bannerIcon
          }
        pastDueSubscriptionIds
      }
    }
  }
`;

export type WhoAmIBasic = {
    userKey: Number,
    firstName: String,
    lastName: String,
    email: String,
    phoneNumber: String,
    createdAt: Date
}

export type Agreement = {
  name: string;
  url: string;
  isSigned: boolean;
  signedOn: Date;
};

export type Price = {
  unitAmount: number;
  displayInterval: string;
};

export type Product = {
  name: string;
  prices: Price[];
};

export type Subscription = {
  activatedAt: Date;
  products: Product[];
};

export type Metadata = {
  deviceOS: string;
  deviceOSVersion: string;
  appVersionName: string;
};

export type UserInsights = {
  userHealth: number;
};

export type WhoAmIWithSubscriptionsAndAgreements = {
  userKey: number;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  createdAt: Date;
  subscription: Subscription;
  agreements: Agreement[];
  metadata: Metadata;
  userInsights?: UserInsights;
};

export const GQL_WhoAmIWithSubscriptionsAndAgreements = gql`
  query {
    whoami {
      userKey
      firstName
      lastName
      email
      phoneNumber
      createdAt
      subscription {
        activatedAt
        products {
          name
          prices {
            unitAmount
            displayInterval
            usageType
          }
        }
      }
      agreements {
        name
        url
        isSigned
        signedOn
      }
      metadata{
        deviceOS
        deviceOSVersion
        appVersionName
      }
    }
  }
`;

export const GQL_UserInsights = gql`
  query {
    whoami {
      userInsights {
        userHealth
      }
    }
  }
`;

export const GQL_SubscriptionPaymentInfoGet = gql`
  query SubscriptionPaymentInfoGet {
    subscriptionPaymentInfoGet {
      subscriptions {
        createdAt
        products {
          name
          prices {
            unitAmount
            displayInterval
            usageType
          }
        }
      }
    }
  }
`;

export const GQL_UserEdit = gql`
  mutation userEdit(
    $firstName: String!
    $lastName: String!
    $email: String!
  ) {
    userEdit(input:{
      firstName: $firstName
      lastName: $lastName
      email: $email
    }) {
      user {
        firstName
        lastName
        email
      }
    }
  }
`;

export const GQL_JediUserEdit = gql`
  mutation userEdit(
    $phoneNumber: String!
    $userKey: Int!
  ) {
    jediUserEdit(input:{
      userKey: $userKey
      phoneNumber: $phoneNumber
    }) {
      user {
        phoneNumber
      }
    }
  }
`;